import { withTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement } from 'react';
import '../utilities/get-styleprop.js';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';

const Pager = ({
  page,
  active,
  onClick,
  onKeyPress,
  itemRender,
  theme
}) => {
  const handleClick = () => {
    onClick(page);
  };
  const handleKeyPress = e => {
    onKeyPress(e, onClick, page);
  };
  const isDisabled = !page;
  return /*#__PURE__*/createElement(Button, {
    onClick: handleClick,
    onKeyPress: handleKeyPress,
    tabIndex: 0,
    active: active,
    disabled: isDisabled,
    styles: {
      root: {
        mr: `${theme.spacing.xs}px`
      }
    },
    small: true,
    variant: "tertiary"
  }, itemRender(page, 'page', /*#__PURE__*/createElement("a", null, page)));
};
var Pager$1 = withTheme(Pager);

export default Pager$1;
